<template>
  <HeaderComponent></HeaderComponent>
  <div align="center">
    <div
      class="imprint"
      align="start"
      style="font-family: Verdana, Geneva, Tahoma, sans-serif"
    >
      <h1 class="mt-10" style="font-size: xxx-large">Impressum</h1>
      <br />
      <div>
        <h3 style="font-size: xx-large">MEDCIRCLE</h3>
        <br />
        Georgenstraße 35<br />
        80799 München <br />
        <a href="mailto:p.dwivedi@campus.lmu.de">p.dwivedi@campus.lmu.de</a>
        <br />
      </div>
      <br />
      <div>
        <h3>Vertreten durch:</h3>
        Paras Dwivedi<br />
      </div>
      <br />

      <div>
        <h3>Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV:</h3>
        <br />
        Paras Dwivedi <br />
        Adelheidstraße 13<br />
        80798 München <br />
      </div>
      <br />

      <div>
        <h3>Haftungsausschluss:</h3>
        <h3>Haftung für Inhalte</h3>
        Die Inhalte unserer Seiten wurden mit größter Sorgfalt erstellt. Für die
        Richtigkeit, Vollständigkeit und Aktualität der Inhalte können wir
        jedoch keine Gewähr übernehmen. Als Diensteanbieter sind wir gemäß § 7
        Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen
        Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als
        Diensteanbieter jedoch nicht verpflichtet, übermittelte oder
        gespeicherte fremde Informationen zu überwachen oder nach Umständen zu
        forschen, die auf eine rechtswidrige Tätigkeit hinweisen.
        Verpflichtungen zur Entfernung oder Sperrung der Nutzung von
        Informationen nach den allgemeinen Gesetzen bleiben hiervon unberührt.
        Eine diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt der
        Kenntnis einer konkreten Rechtsverletzung möglich. Bei Bekanntwerden von
        entsprechenden Rechtsverletzungen werden wir diese Inhalte umgehend
        entfernen.<br /><br />
        <h3>Haftung für Links</h3>
        Unser Angebot enthält Links zu externen Webseiten Dritter, auf deren
        Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden
        Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten
        Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten
        verantwortlich. Die verlinkten Seiten wurden zum Zeitpunkt der
        Verlinkung auf mögliche Rechtsverstöße überprüft. Rechtswidrige Inhalte
        waren zum Zeitpunkt der Verlinkung nicht erkennbar. Eine permanente
        inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne konkrete
        Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei Bekanntwerden
        von Rechtsverletzungen werden wir derartige Links umgehend entfernen.<br /><br />
        <h3>Urheberrecht</h3>
        Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen
        Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung,
        Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der
        Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des
        jeweiligen Autors bzw. Erstellers. Downloads und Kopien dieser Seite
        sind nur für den privaten, nicht kommerziellen Gebrauch gestattet.
        Soweit die Inhalte auf dieser Seite nicht vom Betreiber erstellt wurden,
        werden die Urheberrechte Dritter beachtet. Insbesondere werden Inhalte
        Dritter als solche gekennzeichnet. Sollten Sie trotzdem auf eine
        Urheberrechtsverletzung aufmerksam werden, bitten wir um einen
        entsprechenden Hinweis. Bei Bekanntwerden von Rechtsverletzungen werden
        wir derartige Inhalte umgehend entfernen.
      </div>
    </div>
  </div>
  <FooterComponent></FooterComponent>
</template>

<script setup lang="ts">
import FooterComponent from "@/components/Footer/FooterComponent.vue"
import HeaderComponent from "@/components/Header/HeaderComponent.vue"
import { computed } from "vue"
import { useI18n } from "vue-i18n"
import { useMeta } from "vue-meta"
FooterComponent
const { t } = useI18n()
useMeta(
  computed(() => ({
    title: t("meta.imprint"),
  }))
)
</script>

<style scoped>
.imprint {
  width: 70%;
}
@media screen and (max-width: 800px) {
  .imprint {
    width: 90%;
  }
}
</style>
